<template>
  <div v-click-outside="() => (isOpenSearchList = false)">
    <div class="relative w-full h-full">
      <i-material-symbols-search-rounded
        class="text-[20px] md:text-[30px] text-primary absolute z-10"
        :class="{
          'right-4 top-[4px] md:top-[20%]': !isMobile,
          'right-[12px] md:top-[13%] top-[10px]': isMobile,
        }"
      ></i-material-symbols-search-rounded>
      <input
        v-model="query"
        type="text"
        class="search-input text--sm border-[2px] border-primary text-black"
        :class="{
          'bg-white': isMobile,
          'h-full': !isMobile,
        }"
        :placeholder="$t('common.search-kids')"
        @focus="() => (isOpenSearchList = true)"
      />
      <ProductSearchListKids
        v-if="isOpenSearchList && query?.length"
        :products="productSearchStore.getProducts"
        :class="{
          'absolute top-10': isMobile,
        }"
        @close-list="isOpenSearchList = false"
        @scrolled-to-bottom="productSearchStore.loadProducts"
      />
    </div>
  </div>
</template>
<script setup>
import { watch, ref } from "vue"
import ProductSearchListKids from "./ProductSearchListKids.vue"
import { useProductSearchStore } from "@/stores/productSearchStore"

defineProps({
  isMobile: {
    type: Boolean,
    default: false,
  },
})

const productSearchStore = useProductSearchStore()

const query = ref(null)
const timer = ref(null)
const isOpenSearchList = ref(false)

const setQuery = () => {
  clearTimeout(timer.value)

  timer.value = setTimeout(() => {
    search(query.value)
  }, 500)
}

const search = (query) => {
  productSearchStore.setProductQuery(query)
}

watch(query, () => {
  setQuery()
})
</script>

<style scoped lang="scss">
.search-input {
  @apply w-full md:py-[14px] md:px-6  px-3 py-[11px] bg-white rounded-[14px] border-[2px] border-primary;
  color: #242d21;
  &::placeholder {
    color: #8e8e8e;
  }
}
</style>
